import React from "react";
import {
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { removeNotification } from "../../../store/slices/appSlice";
import { getNotificationNavigatePath } from "../../../utils/notificationHelpers";
import { useNotificationModal } from "../../../hooks/useNotificationModal";
import userTypes from "../../../constants/userTypes";
import { appColors } from "../../../constants/theme";

const CustomMessageNotificationMenu = ({
  anchorEl,
  open,
  handleClose,
  list,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { open: openNotificationModal } = useNotificationModal();
  const userTypeUpper = String(
    useSelector((state) => state.auth?.user?.userType || state.auth?.role?.name || "")
  ).toUpperCase();
  const isDoctor = userTypeUpper === userTypes.DOCTOR;

  const handleClick = (item) => {
    handleClose();
    dispatch(removeNotification(item.id));
    if (isDoctor) {
      openNotificationModal(item);
      return;
    }
    const path = getNotificationNavigatePath(item);
    if (path) {
      navigate(path);
    }
  };

  const handleViewAll = () => {
    handleClose();
    if (isDoctor) {
      navigate("/notifications");
    }
  };

  return (
    <Menu
      anchorEl={anchorEl}
      id="message-notifications"
      open={open}
      onClose={handleClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      marginThreshold={12}
      PaperProps={{
        sx: {
          maxWidth: { xs: "calc(100vw - 24px)", md: 360 },
          width: { xs: "calc(100vw - 24px)", sm: 340 },
          borderRadius: 2,
          overflow: "hidden",
        },
      }}
    >
      <List sx={{ width: "100%", maxHeight: { xs: 320, md: 400 }, overflowY: "auto", bgcolor: "background.paper", py: 0 }}>
        {list.length === 0 ? (
          <Typography sx={{ textAlign: "center", px: 2, py: 2 }}>
            {t("no_new_notifications")}
          </Typography>
        ) : (
          list.map((item, index) => (
            <React.Fragment key={item.id ?? index}>
              <ListItem disablePadding>
                <ListItemButton onClick={() => handleClick(item)} alignItems="flex-start">
                  <ListItemText
                    primary={item.title || t("notifications")}
                    secondary={item.body || ""}
                    primaryTypographyProps={{
                      fontWeight: 600,
                      fontSize: "0.9rem",
                      color: appColors.gray900,
                    }}
                    secondaryTypographyProps={{
                      fontSize: "0.8rem",
                      sx: {
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      },
                    }}
                  />
                </ListItemButton>
              </ListItem>
              {index + 1 < list.length && <Divider />}
            </React.Fragment>
          ))
        )}
      </List>
      {isDoctor && (
        <Box sx={{ px: 1.5, py: 1, borderTop: `1px solid ${appColors.gray200}` }}>
          <Button fullWidth size="small" onClick={handleViewAll} sx={{ textTransform: "none" }}>
            {t("view_all_notifications")}
          </Button>
        </Box>
      )}
    </Menu>
  );
};

export default CustomMessageNotificationMenu;
